import * as api from '../../services/price_level/api_price_level';
import * as apiCommon from '../../services/apiCommon';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import * as SagaCommon from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* fetchListPriceLevelSaga(feathersApp) {
    yield takeLatest('FETCH_LIST_PRICE_LEVEL', callFetchListPriceLevel, feathersApp);
}

function* callFetchListPriceLevel(feathersApp, action) {
    const { silent, filters } = action;
    yield SagaCommon.showProgressListTable(silent);
    try {
        const dataParams = {
            filters,
            list_type: 'price_level'
        };
        const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
        yield call(SagaCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total });
    } catch (error) {
        yield SagaCommon.showErrorListTable(error);
    }
}


export function* savePriceLevelSaga(feathersApp) {
    yield takeEvery("SAVE_PRICE_LEVEL", callSavePriceLevel, feathersApp);
}
function* callSavePriceLevel(feathersApp, action) {
    const { tenant, user } = yield select();
    try {
        yield put({ type: 'SAVE_RECORD_INPROGRESS' });

        const params = { tenant, user, data: action.data };
        const result = yield call(api.savePriceLevel, feathersApp, params);
        const id = result && result.id;

        if (id) {
            yield callFetchListPriceLevel(feathersApp, { silent: true });
            yield SagaCommon.doneSaveRecord(result, 'Price level was saved');
            yield put({
                type: SagasType.SIMPLE_FORM_SET_DATA,
                data: result
            });

        } else {
            yield SagaCommon.showErrorSaveRecord(new Error('Error in saving : Price level'));
        }
    } catch (e) {
        yield SagaCommon.showErrorSaveRecord(e);
    }
}

export function* deletePriceLevelFromListSaga(feathersApp) {
    yield takeEvery('DELETE_PRICE_LEVEL_FROM_LIST', callDeletePriceLevelFromList, feathersApp);
}

function* callDeletePriceLevelFromList(feathersApp, action) {
    yield deletePriceLevel(feathersApp, action);
    yield delay(2000);
    yield callFetchListPriceLevel(feathersApp, { silent: true });
}

function* deletePriceLevel(feathersApp, action) {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });
    try {
        const { id } = action;
        let result = null;
        if (id) {
            const state = yield select();
            const { tenant, user } = state;
            const params = { tenant, user, id };
            result = yield call(api.deletePriceLevel, feathersApp, params);
            yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.PRICE_LEVEL } });
            yield callFetchListPriceLevel(feathersApp, { silent: true });
        }
        return result;
    } catch (error) {
        yield put({ type: 'DELETE_RECORD_ERROR', error })
    }
}

export function* deletePriceLevelSaga(feathersApp) {
    yield takeEvery('DELETE_PRICE_LEVEL', callDeletePriceLevel, feathersApp);
}

function* callDeletePriceLevel(feathersApp, action) {
    const result = yield deletePriceLevel(feathersApp, action);
    yield delay(2000);
    if (result) {
        browserHistory.push('/admin/price_level');
    }
}

export function* fetchPriceLevelForEditSaga(feathersApp) {
    yield takeEvery('FETCH_PRICE_LEVEL_BY_ID', callFetchPriceLevelForEdit, feathersApp);
}

function* callFetchPriceLevelForEdit(feathersApp, action) {
    const { tenant, user } = yield select();
    const { id } = action;
    const docType = DocType.PRICE_LEVEL;
    try {
        if (id) {
            yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
            const fetchParams = { tenant, user, id };
            const doc = yield call(api.fetchPriceLevelById, feathersApp, fetchParams);
            yield SagaCommon.doneDataById(doc);
            yield put({
                type: SagasType.SIMPLE_FORM_SET_DATA,
                data: doc
            });
        }
    } catch (error) {
        yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
    }
}
